var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, ButtonVariant } from '@patternfly/react-core';
import { CloseIcon } from '@patternfly/react-icons';
import { createUseStyles } from 'react-jss';
import { css } from '@patternfly/react-styles';
const useStyles = createUseStyles({
    closeButton: {
        float: 'inline-end',
        padding: '10px 14px'
    },
});
;
export const CloseButton = (_a) => {
    var { className, dataTestID, onClick, ouiaId = "CloseButton" } = _a, props = __rest(_a, ["className", "dataTestID", "onClick", "ouiaId"]);
    const classes = useStyles();
    return (_jsx(Button, Object.assign({ icon: _jsx(CloseIcon, {}), "aria-label": props['aria-label'] || 'Close', className: css(classes.closeButton, className), "data-test-id": dataTestID, onClick: onClick, variant: ButtonVariant.plain, ouiaId: ouiaId }, props)));
};
export default CloseButton;
